import { baseApi } from "configs/store-query";

export const apiService = baseApi;
export const currentVersion = 1;
